export default __webpack_public_path__ + "static/media/gallery_01.aee9960a.jpg";